import { get, post, put, del } from '../util/http';
import { ENDPOINTS } from '../util/endpoints';

export const pointTypeService = {
  list:    (params)       => get(ENDPOINTS.pointTypes.list, { params }),
  search:  (params)       => get(ENDPOINTS.pointTypes.search, { params }),
  create:  (data)         => post(ENDPOINTS.pointTypes.list, data),
  update:  (id, data)     => put(ENDPOINTS.pointTypes.byId(id), data),
  remove:  (id)           => del(ENDPOINTS.pointTypes.byId(id)),
};
